import { AsyncPipe } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-btn-more',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './btn-more.component.html',
  styleUrl: './btn-more.component.css',
})
export class BtnMoreComponent {
  btnText = input<string>('Show More');
  @Input() isDisabled: boolean = false;
  @Input() inProgress$: Observable<boolean> = new Observable<boolean>();

  constructor() {}
}
